import React from 'react';
import './BisTextfield.css';
import PropTypes from "prop-types";

const BisTextfield = ({id, label, value, onChange, readOnly = false, error}) => {
    return (
        <div className="bis_textfield">
            <label className="bis_textfield-label" htmlFor={id}>{label}</label>
            <input
                id={id}
                className={`bis_textfield-input ${readOnly ? 'readonly' : ''}`}
                type="text"
                value={value}
                onChange={onChange}
                readOnly={readOnly}
                aria-readonly={readOnly ? "true" : "false"}
                aria-describedby={error ? `${id}-error` : undefined}
                aria-invalid={error ? "true" : "false"}
            />
            {error && (
                <div id={`${id}-error`} className="bis_textfield-error show" role="alert">
                    {error}
                </div>
            )}
        </div>
    );
}

BisTextfield.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    error: PropTypes.string,
};

export default BisTextfield;
